<ngx-loading-bar color="#d20a11" height="2px" [includeSpinner]="false" ref="http"></ngx-loading-bar>
<router-outlet></router-outlet>
